var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, Input, ViewChild, Output, EventEmitter, Inject } from '@angular/core';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
import * as _ from 'lodash';
import { WordExceptBHDataType } from '../../../core/variable/flag-data-type';
import { finalize } from 'rxjs/operators';
import { VariableName } from '../../../core/variable/variable-name';
import { VARIABLE_SERVICE } from '../../../core/variable/variable.service';
var GeneralPropertyComponent = /** @class */ (function (_super) {
    __extends(GeneralPropertyComponent, _super);
    function GeneralPropertyComponent(injector, variableService, dataTypeService, barDirectionService) {
        var _this = _super.call(this, injector) || this;
        _this.variableService = variableService;
        _this.dataTypeService = dataTypeService;
        _this.barDirectionService = barDirectionService;
        _this.validateChange = new EventEmitter();
        _this.integerFractionDigitError = '';
        _this.dataType = WordExceptBHDataType;
        return _this;
    }
    Object.defineProperty(GeneralPropertyComponent.prototype, "currentVariableId", {
        get: function () {
            return this._currentVariableId;
        },
        set: function (v) {
            if (VariableName.equals(v, this._currentVariableId)) {
                return;
            }
            this._currentVariableId = v;
            this.data.configureVariableId = v;
            this.currentVariableIdChanged();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeneralPropertyComponent.prototype, "currentVariable", {
        get: function () {
            return this._currentVariable;
        },
        set: function (v) {
            if (v === this._currentVariable) {
                return;
            }
            this._currentVariable = v;
            this.data.variableDataType = v.dataType;
            this.validateMinMaxValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeneralPropertyComponent.prototype, "selectedBarDirectionValue", {
        get: function () {
            return this._direction;
        },
        set: function (v) {
            this.data.direction = v;
            this._direction = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeneralPropertyComponent.prototype, "minValue", {
        get: function () {
            return this._minValue;
        },
        set: function (v) {
            this.data.minValue = v;
            this._minValue = v;
            this.validateErrorEmit();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeneralPropertyComponent.prototype, "maxValue", {
        get: function () {
            return this._maxValue;
        },
        set: function (v) {
            this.data.maxValue = v;
            this._maxValue = v;
            this.validateErrorEmit();
        },
        enumerable: true,
        configurable: true
    });
    GeneralPropertyComponent.prototype.ngOnInit = function () {
        this.initData();
    };
    GeneralPropertyComponent.prototype.validateMinValue = function () {
        if (_.isNil(this.minValue)) {
            this.minValue = 0;
            return;
        }
        if (this.currentVariable) {
            if (this.currentVariable.dataType) {
                var dataTypeMinValue = this.dataTypeService.getMinValue(this.currentVariable.dataType);
                this.minValue = this.minValue < dataTypeMinValue ? dataTypeMinValue : this.minValue;
            }
        }
    };
    GeneralPropertyComponent.prototype.validateMaxValue = function () {
        if (_.isNil(this.maxValue)) {
            this.maxValue = 0;
            return;
        }
        if (this.currentVariable) {
            if (this.currentVariable.dataType) {
                var dataTypeMaxValue = this.dataTypeService.getMaxValue(this.currentVariable.dataType);
                this.maxValue = this.maxValue > dataTypeMaxValue ? dataTypeMaxValue : this.maxValue;
            }
        }
    };
    GeneralPropertyComponent.prototype.validateMinMaxValue = function () {
        if (this.currentVariable && this.currentVariable.dataType) {
            var dataTypeMaxValue = this.dataTypeService.getMaxValue(this.currentVariable.dataType);
            this.maxValue = this.maxValue > dataTypeMaxValue ? dataTypeMaxValue : this.maxValue;
            var dataTypeMinValue = this.dataTypeService.getMinValue(this.currentVariable.dataType);
            this.minValue = this.minValue < dataTypeMinValue ? dataTypeMinValue : this.minValue;
        }
    };
    GeneralPropertyComponent.prototype.validateErrorEmit = function () {
        var validateError = (this.integerFractionDigitError !== ''
            || this._maxValue <= this._minValue);
        this.validateChange.emit(validateError);
    };
    GeneralPropertyComponent.prototype.initData = function () {
        var _this = this;
        this.barDirectionList = this.barDirectionService.getBarDirection();
        var data = this.data;
        if (data.configureVariableId.variableVersion) {
            this.currentVariableId = VariableName.tryParse(data.configureVariableId.name, data.configureVariableId.variableVersion);
        }
        else if (!_.isNil(data.variableId.dataSourceCode)) {
            this.variableService.getVariableName(data.variableId.dataSourceCode, data.variableId.variableName.name, data.variableId.variableName.groupName).subscribe(function (value) {
                _this.currentVariableId = value;
            });
        }
        this._direction = data.direction;
        this._minValue = data.minValue;
        this._maxValue = data.maxValue;
    };
    GeneralPropertyComponent.prototype.currentVariableIdChanged = function () {
        var _this = this;
        var variableId = this.currentVariableId;
        if (variableId && variableId.name) {
            this.isLoading = true;
            this.variableService.findVariable(variableId)
                .pipe(finalize(function () {
                _this.isLoading = false;
            }))
                .subscribe(function (variable) {
                _this.currentVariable = variable;
            });
        }
        else {
            this.currentVariable = undefined;
        }
    };
    __decorate([
        Input()
    ], GeneralPropertyComponent.prototype, "configureId", void 0);
    __decorate([
        ViewChild('minValueInput', { static: false })
    ], GeneralPropertyComponent.prototype, "minValueInput", void 0);
    __decorate([
        Input()
    ], GeneralPropertyComponent.prototype, "data", void 0);
    __decorate([
        Output()
    ], GeneralPropertyComponent.prototype, "validateChange", void 0);
    GeneralPropertyComponent = __decorate([
        Component({
            selector: 'general-property',
            template: "<div class=\"fe-modal-content\" [busyIf]=\"isLoading\"> <div class=\"fe-vertical-label\"> <div class=\"fe-vertical-title\">{{lc(\"BarDirection\")}}:</div> <div class=\"fe-vertical-component\"> <select name=\"direction\" [(ngModel)]=\"selectedBarDirectionValue\"> <option *ngFor=\"let barDirection of barDirectionList\" [ngValue]=\"barDirection.value\"> {{barDirection.name}} </option> </select> </div> </div> <div class=\"clearfix\"> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc(\"MinimumValue\")}}</div> <input type=\"number\" #minValueInput class=\"fe-vertical-input\" name=\"graduatedMin\" [(ngModel)]=\"minValue\" (change)=\"validateMinValue()\" required/> </div> <div class=\"fe-vertical-label fe-half-line\"> <div class=\"fe-vertical-title\">{{lc(\"MaximumValue\")}}</div> <input type=\"number\" class=\"fe-vertical-input\" name=\"graduatedMax\" [(ngModel)]=\"maxValue\" (change)=\"validateMaxValue()\" required/> </div> </div> <div *ngIf=\"minValue>=maxValue\"> <div class=\"fe-vertical-title has-danger\"> <div class=\"form-control-feedback\">{{lc(\"MaximumMinimumValidateInfo\")}}</div> </div> </div> <div class=\"clearfix\"> <div class=\"fe-vertical-label\"> <div class=\"fe-vertical-title\">{{lc(\"VariableName\")}}:</div> <div class=\"fe-vertical-component\"> <variable-selector [configureId]=\"configureId\" [(currentVariableId)]=\"currentVariableId\" [dataType]=\"dataType\"></variable-selector> </div> </div> </div> </div>"
        }),
        __param(1, Inject(VARIABLE_SERVICE))
    ], GeneralPropertyComponent);
    return GeneralPropertyComponent;
}(ConfigureComponentBase));
export { GeneralPropertyComponent };
